import { Injectable } from '@angular/core';

import { SportsCacheService } from '@frontend/sports/betting-offer/feature/sports-cache';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { CountItem } from '@frontend/sports/common/core/data-access/sport-model';
import { CompetitionRouteService } from '@frontend/sports/competition-list/feature';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { map } from 'rxjs';

import { BreadcrumbModel } from '../../breadcrumbs/breadcrumb.models';
import { BreadcrumbResult, IBreadcrumbsResolve } from '../../breadcrumbs/breadcrumbs.resolver';

@Injectable()
export class SportBreadcrumbsResolver implements IBreadcrumbsResolve {
    constructor(
        private sitecore: Sitecore,
        private urlHelper: UrlHelperService,
        private route: CompetitionRouteService,
        private cache: SportsCacheService,
    ) {}

    resolve(): BreadcrumbResult {
        const { sport } = this.route.params();

        if (sport) {
            return this.cache.getSport(sport).pipe(map(this.map));
        }

        return [];
    }

    private map = (sport?: CountItem) => {
        const breadcrumbs: BreadcrumbModel[] = [];
        if (!sport) {
            return breadcrumbs;
        }

        const title = this.sitecore.seo.SportBreadcrumbTitle.replace(/{{sport}}/, sport.name);

        if (sport.isEsport) {
            breadcrumbs.push({
                icon: 'theme-e-sports',
                title: this.sitecore.eSports.ESports,
                url: this.urlHelper.getESportsUrl(),
            });
        }

        breadcrumbs.push({ icon: `sports-${sport.id}`, title, url: this.urlHelper.getSportUrl(sport) });

        return breadcrumbs;
    };
}
